module.exports = __webpack_public_path__ + "img/licenseSeats.0dd1e641.svg";